import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      display: 'grid',
      gridTemplateAreas: `
        "heading"
        "toolbar"
      `,
      gridTemplateRows: 'auto auto',
      gridTemplateColumns: '100%',
      gap: theme.spacing(1.5),
      padding: theme.spacing(1, 2),
    },
    rootHasChildren: {
      height: '100%',
      gridTemplateAreas: `
        "heading"
        "toolbar"
        "content"
      `,
      gridTemplateRows: 'auto auto 1fr',
    },
    heading: {
      gridArea: 'heading',
    },
    toolbar: {
      gridArea: 'toolbar',
      display: 'grid',
      gridTemplateAreas: `"main actions"`,
      gridTemplateColumns: '1fr auto',
    },
    toolbarMain: {
      gridArea: 'main',
    },
    toolbarActions: {
      display: 'flex',
      alignItems: 'center',
      gridArea: 'actions',
      padding: theme.spacing(1),
    },
    contentWrapper: {
      gridArea: 'content',
      maxHeight: '100%',
      position: 'relative',
    },
    content: {
      width: '100%',
      height: '100%',
      position: 'absolute',
    },
  };
};
